var PAGE_TYPE = {
  PERSONAL_INFO: 'registration-personal-info',
  PERSONAL_STATUS: 'registration-info-member',
  EMPLOYER: 'registration-employer',
  ENROLL: 'registration-enroll',
  AGENCY: 'registration-agency',
  INSURANCE: 'registration-insurance',
  CONFIRMATION: 'registration-confirmation',
  END: 'registration-end'
};

module.exports = PAGE_TYPE;
